<template>
  <div class="percentage-increase-or-decrease">
    <div v-if="increment">
      <v-icon class="increment-icon">mdi-triangle</v-icon>
      &nbsp;<span class="increment-span"
        >{{ percentageIncreaseOrDecrease }}%</span
      >
    </div>

    <div v-if="remainsTheSame">
      &nbsp;<span class="remains-the-same-span">-%</span>
    </div>

    <div v-if="decrement">
      <v-icon class="decrement-icon">mdi-triangle</v-icon>
      &nbsp;<span class="decrement-span">
        {{ percentageIncreaseOrDecrease }}%
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PercentageIncreaseOrDecrease",
  props: {
    quantity1: {
      type: Number,
      default: null
    },
    quantity2: {
      type: Number,
      default: null
    }
  },
  computed: {
    increment() {
      return this.quantity1 > this.quantity2;
    },
    decrement() {
      return this.quantity1 < this.quantity2;
    },
    remainsTheSame() {
      return this.quantity1 === this.quantity2;
    },
    percentageIncreaseOrDecrease() {
      // Increment
      if (this.increment) {
        let diff = this.quantity1 - this.quantity2;
        return Math.round((diff / this.quantity1) * 100);
      }

      // Decrement
      if (this.decrement) {
        let diff = this.quantity2 - this.quantity1;
        return Math.round((diff / this.quantity2) * 100);
      }

      return 0;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
